export default "__VITE_ASSET__DjZc1v93__"